var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelecommunication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.90147 13.7749C6.32814 14.1143 4.91964 14.985 3.91281 16.2407C2.90598 17.4964 2.36222 19.0605 2.37295 20.67L2.35742 22.0521C2.36442 22.6719 2.61373 23.2643 3.05199 23.7025C3.49024 24.1408 4.08263 24.3901 4.70239 24.3971L10.6036 24.366C11.2198 24.3607 11.8092 24.1135 12.2448 23.6779C12.6806 23.2421 12.9277 22.6527 12.9331 22.0366C12.94 21.4169 13.1894 20.8245 13.6276 20.3862C14.0659 19.9479 14.6583 19.6986 15.278 19.6916H24.5958C24.9043 19.6894 25.2103 19.7485 25.4958 19.8655C25.7813 19.9826 26.0407 20.1552 26.2589 20.3734C26.4771 20.5916 26.6498 20.851 26.7668 21.1365C26.8839 21.4221 26.943 21.728 26.9407 22.0366C26.9461 22.6527 27.1932 23.2421 27.6289 23.6779C28.0646 24.1135 28.6541 24.3607 29.2701 24.366H35.1713C35.7912 24.359 36.3835 24.1097 36.8219 23.6715C37.2599 23.2332 37.5094 22.6408 37.5162 22.0211L37.5008 20.6389C37.5116 19.0295 36.9679 17.4654 35.9608 16.2096C34.9541 14.9539 33.5455 14.0832 31.9722 13.7438C24.02 12.2209 15.8498 12.2314 7.90147 13.7749Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelecommunication);
export default __webpack_public_path__ + "static/media/Telecommunication.4bc93122bea442b131200603961bcae9.svg";
export { ForwardRef as ReactComponent };